(function () {
  'use strict';

  function bindAuraDrawer(drawer) {
    if (!drawer || drawer.dataset.cruxAuraFocusReturn === 'true') return;

    var container = drawer.querySelector('details');
    var trigger = drawer.querySelector('summary[aria-label="Menu"]');
    if (!container || !trigger) return;

    drawer.dataset.cruxAuraFocusReturn = 'true';
    var wasOpen = container.hasAttribute('open');

    container.addEventListener('toggle', function () {
      var isOpen = container.hasAttribute('open');
      if (wasOpen && !isOpen) {
        window.requestAnimationFrame(function () {
          trigger.focus({ preventScroll: true });
        });
      }
      wasOpen = isOpen;
    });
  }

  function initializeAuraDrawers(root) {
    if (!document.body.matches("body[data-crux-world='aura']:not(.crux-twin-worlds-home)")) return;
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('#header-group header-drawer'), bindAuraDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAuraDrawers(document);
    });
  } else {
    initializeAuraDrawers(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAuraDrawers(event.target);
  });
})();

/* CRUX AURA mobile directional sticky controller JS v4 */
(function () {
  'use strict';

  var BODY_SELECTOR = "body[data-crux-world='aura']:not(.crux-twin-worlds-home)";
  var STICKY_SELECTOR = "#header-group #header-component[sticky='scroll-up']";
  var ACTIVE_CLASS = 'crux-aura-mobile-header-sticky';
  var BOUND_ATTRIBUTE = 'data-crux-mobile-scroll-controller';
  var DIRECTION_THRESHOLD = 14;
  var MOBILE_QUERY = '(max-width: 749px)';

  function initialize(root) {
    if (!document.body.matches(BODY_SELECTOR)) return;

    var scope = root && root.querySelectorAll ? root : document;
    var groups = [];
    if (scope.matches && scope.matches('#header-group')) groups.push(scope);
    if (scope.closest) {
      var ancestor = scope.closest('#header-group');
      if (ancestor && groups.indexOf(ancestor) === -1) groups.push(ancestor);
    }
    Array.prototype.forEach.call(scope.querySelectorAll('#header-group'), function (group) {
      if (groups.indexOf(group) === -1) groups.push(group);
    });

    groups.forEach(function (group) {
      if (group.getAttribute(BOUND_ATTRIBUTE) === 'true') return;
      if (!group.querySelector(STICKY_SELECTOR)) return;

      group.setAttribute(BOUND_ATTRIBUTE, 'true');
      var media = window.matchMedia(MOBILE_QUERY);
      var lastY = Math.max(0, window.scrollY || window.pageYOffset || 0);
      var lastDirection = 0;
      var directionTravel = 0;
      var framePending = false;

      function resetAt(y) {
        lastY = y;
        lastDirection = 0;
        directionTravel = 0;
        group.classList.remove(ACTIVE_CLASS);
      }

      function processScroll() {
        framePending = false;
        var y = Math.max(0, window.scrollY || window.pageYOffset || 0);

        if (!media.matches) {
          resetAt(y);
          return;
        }

        if (y <= 1) {
          resetAt(y);
          return;
        }

        var delta = y - lastY;
        lastY = y;
        if (Math.abs(delta) < 1) return;

        var direction = delta > 0 ? 1 : -1;
        if (direction !== lastDirection) {
          lastDirection = direction;
          directionTravel = 0;
        }
        directionTravel += Math.abs(delta);

        if (directionTravel < DIRECTION_THRESHOLD) return;
        if (direction < 0) group.classList.add(ACTIVE_CLASS);
        else group.classList.remove(ACTIVE_CLASS);
      }

      function onScroll() {
        if (framePending) return;
        framePending = true;
        window.requestAnimationFrame(processScroll);
      }

      function onBreakpointChange() {
        resetAt(Math.max(0, window.scrollY || window.pageYOffset || 0));
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('pageshow', onBreakpointChange);
      if (media.addEventListener) media.addEventListener('change', onBreakpointChange);
      else if (media.addListener) media.addListener(onBreakpointChange);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();

/* CRUX AURA desktop/tablet single-event scroll reveal JS v1 */
(() => {
  'use strict';

  const BODY_SELECTOR = "body[data-crux-world='aura']:not(.crux-twin-worlds-home)";
  const GROUP_SELECTOR = '#header-group';
  const HEADER_SELECTOR = "#header-component[sticky='scroll-up']";
  const REVEAL_CLASS = 'crux-aura-desktop-header-reveal';
  const TOP_CLASS = 'crux-aura-desktop-header-at-top';
  const BOUND_ATTRIBUTE = 'data-crux-desktop-scroll-reveal';
  const DESKTOP_QUERY = '(min-width: 750px)';
  const DIRECTION_THRESHOLD = 4;

  const bind = (group) => {
    const header = group.querySelector(HEADER_SELECTOR);
    if (!header || group.getAttribute(BOUND_ATTRIBUTE) === 'true') return;

    group.setAttribute(BOUND_ATTRIBUTE, 'true');
    const media = window.matchMedia(DESKTOP_QUERY);
    let lastY = Math.max(0, window.scrollY || window.pageYOffset || 0);
    let framePending = false;

    const clearClasses = () => {
      group.classList.remove(REVEAL_CLASS, TOP_CLASS);
    };

    const processScroll = () => {
      framePending = false;
      const y = Math.max(0, window.scrollY || window.pageYOffset || 0);
      const delta = y - lastY;
      const topThreshold = Math.max(120, header.offsetHeight + 32);
      lastY = y;

      if (!media.matches) {
        clearClasses();
        return;
      }

      if (y <= topThreshold) {
        group.classList.remove(REVEAL_CLASS);
        group.classList.add(TOP_CLASS);
        return;
      }

      if (delta <= -DIRECTION_THRESHOLD) {
        group.classList.add(REVEAL_CLASS);
        group.classList.remove(TOP_CLASS);
      } else if (delta >= DIRECTION_THRESHOLD) {
        clearClasses();
      }
    };

    const onScroll = () => {
      if (framePending) return;
      framePending = true;
      window.requestAnimationFrame(processScroll);
    };

    const reset = () => {
      lastY = Math.max(0, window.scrollY || window.pageYOffset || 0);
      clearClasses();
      processScroll();
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('pageshow', reset);
    if (media.addEventListener) media.addEventListener('change', reset);
    else if (media.addListener) media.addListener(reset);
    processScroll();
  };

  const initialize = (root = document) => {
    if (!document.body.matches(BODY_SELECTOR)) return;
    const group = root.matches?.(GROUP_SELECTOR) ? root : root.querySelector?.(GROUP_SELECTOR);
    if (group) bind(group);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
